// i18n area 'tasks' — locale bg-BG (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/tasks.bg-BG.meta.json.
import type { enUS } from './tasks'

export const bgBG: typeof enUS = {
  macrotasks: {
    title: 'Макрозадачи',
    subtitle: 'Съставни операции — възобновими от провалената стъпка или прекъсваеми',
    colType: 'Тип',
    colTarget: 'Обект',
    colPhase: 'Фаза',
    colSteps: 'Стъпки',
    empty: 'Няма макрозадачи',
    detail: 'Детайли',
    failedAt: 'провалена на',
    resume: 'Опитай отново от провалената стъпка',
    abort: 'Прекъсни всичко',
    cancel: 'Отмени',
    actionError: 'Действието беше отказано'
  },
  tasks: {
    title: 'Задачи',
    searchPlaceholder: 'Търси по тип или цел',
    type: 'Тип',
    target: 'Цел',
    phaseLabel: 'Фаза',
    progress: 'Напредък',
    started: 'Започната',
    finished: 'Завършена',
    node: 'Възел',
    empty: 'Няма задачи',
    loadError: 'Неуспешно зареждане на задачите — достъпен ли е бекендът на TVirt?',
    limboHint: "Възел '{node}' е недостъпен от {time} — задачата държи write lease върху целта си, докато възелът не се върне или не бъде атестиран като изключен",
    nodeAttested: 'Възелът е атестиран като изключен',
    phase: {
      queued: 'В опашка',
      running: 'В изпълнение',
      succeeded: 'Завършена успешно',
      failed: 'Провалена',
      cancelled: 'Отменена',
      'failed-at-step': 'Провалена на стъпка',
      aborted: 'Прекъсната'
    },
    dropdown: {
      tooltip: 'Задачи в изпълнение',
      title: 'Задачи в изпълнение',
      empty: 'Няма текущи задачи',
      viewAll: 'Виж всички задачи'
    },
    detail: {
      open: 'Детайли',
      scope: 'Обхват',
      message: 'Съобщение',
      params: 'Параметри',
      result: 'Резултат',
      errorTitle: 'Грешка',
      steps: 'Стъпки',
      failedAt: 'провалена на',
      superseded: 'изместена',

      // Dialog standard (round #156): il posto del figlio nel piano del padre,
      // il padre stesso (apribile in-place) e il passo colpevole.
      step: 'Стъпка',
      parent: 'Родителска задача',
      failedStep: 'Провалена стъпка',
      log: 'Лог',
      logEmpty: 'Още няма редове в лога',
      close: 'Затвори'
    },
    actions: {
      cancel: 'Отмени',
      resume: 'Опитай отново от провалената стъпка',
      abort: 'Прекъсни всичко (завършените стъпки се връщат назад)',
      refused: 'Действието беше отказано'
    }
  },
  events: {
    loadError: 'Дневникът не можа да се зареди — достъпен ли е бекендът на TVirt?',
    title: 'Събития',
    subtitle: 'Историческата памет на клъстера: свършени факти, от най-новите',
    filterSeverity: 'Тежест',
    filterCategory: 'Категория',
    filterAll: 'Всички',
    searchLabel: 'Търсене',
    searchPlaceholder: 'Търси в целия дневник',
    subjectFilter: 'Събития на {subject} — покажи всички',
    colAt: 'Кога',
    colSeverity: 'Тежест',
    colType: 'Тип',
    colSubject: 'Обект',
    colActor: 'Кой',
    colNode: 'Node',
    colMessage: 'Съобщение',
    empty: 'Няма събития',
    loadMore: 'Зареди още',
    actorSystem: 'система',
    detailScope: 'Scope',
    detailTask: 'Task',
    detailId: 'ID на събитието',
    taskCollectedHint: 'Task се пази по-кратко: след събирането му връзката вече не отговаря',
    severity: {
      info: 'Информация',
      warning: 'Предупреждение',
      error: 'Грешка',
      critical: 'Критично'
    },
    category: {
      lifecycle: 'Жизнен цикъл',
      config: 'Конфигурация',
      availability: 'Достъпност',
      security: 'Сигурност'
    },
    type: {
      haNetsvcFailedOver: 'Аварийно превключване на мрежова услуга',
      haNetsvcNoCandidate: 'Мрежова услуга без възел кандидат',
      haNetsvcReaped: 'Локална инстанция, ожъната при завръщането',
      netsvcFloatipMoved: 'Плаващият IP се премести към друг държател',
      netsvcFloatipNoHolder: 'Плаващ IP без здрава цел',
      haAppFailedOver: 'Failover на App инстанцията',
      haAppNoCandidate: 'App инстанция без кандидат възел',
      haAppStorageLocalSkip: 'App инстанцията не е прехвърлена: постоянните данни са локални за мъртвия възел',
      haAppReaped: 'Локалният под на App инстанцията е пожънат при повторно присъединяване'
    }
  },
  audit: {
    loadError: 'Регистърът за одит не можа да се зареди — достъпен ли е бекендът на TVirt?',
    title: 'Одит',
    subtitle: 'Кой какво е направил, кога и върху кой обект — опитани действия, включително отказите',
    filterOutcome: 'Резултат',
    filterAll: 'Всички',
    filterSudo: 'Само повишени действия',
    colAt: 'Кога',
    colActor: 'Кой',
    colAction: 'Действие',
    colTarget: 'Обект',
    colOutcome: 'Резултат',
    colNode: 'Node',
    empty: 'Няма записани действия',
    loadMore: 'Зареди още',
    sudoBadge: 'sudo',
    tokenBadge: 'app token',
    detailScope: 'Scope',
    detailPath: 'Маршрут',
    detailProblem: 'Причина',
    detailTask: 'Task',
    detailClientIp: 'От',
    detailId: 'ID на записа',
    detailSession: 'Сесия',
    taskHint: 'Резултатът от прието действие живее в дневника със събития, под същия id на task',
    outcome: {
      succeeded: 'Успешно',
      accepted: 'Прието',
      denied: 'Отказано',
      rejected: 'Отхвърлено',
      failed: 'Неуспешно'
    }
  },
  notifications: {
    loadError: 'Известията не можаха да се заредят — достъпен ли е бекендът на TVirt?',
    actionError: 'Действието беше отказано',
    title: 'Известия',
    subtitle: 'Местоназначенията, към които фактите на дневника напускат клъстера',
    rulesTitle: 'Правила',
    rulesSubtitle: 'Кои факти излизат и накъде',
    deliveriesTitle: 'Доставки',
    deliveriesSubtitle: 'Резултатът от всяко известие, с причината когато не успее',
    colName: 'Име',
    colKind: 'Тип',
    colWhere: 'Накъде',
    colScope: 'Scope',
    colSeverity: 'Тежест',
    colMatch: 'Филтър',
    colTargets: 'Местоназначение',
    colAt: 'Кога',
    colState: 'Състояние',
    colEvent: 'Събитие',
    colAttempts: 'Опити',
    colOutcome: 'Резултат',
    empty: 'Няма редове',
    matchAll: 'всички факти',
    test: 'Проба',
    testOk: 'Пробното известие е доставено до {target}',
    testFailed: 'Пробата към {target} се провали: {reason}',
    retry: 'Върни в опашката',
    retried: 'Доставката е върната в опашката',
    grouped: 'и още {count} повторения',
    state: {
      failed: 'Неуспешна',
      pending: 'В опашка',
      sending: 'Изпраща се',
      sent: 'Изпратена'
    },
    tabTargets: 'Дестинации',
    tabRules: 'Правила',
    tabDeliveries: 'Доставки',
    targetCreateTitle: 'Нова дестинация',
    ruleCreateTitle: 'Ново правило',
    nameHint: 'Малки букви, цифри и тирета; уникално за обхват',
    kindImmutableHint: 'Непроменимо: смяната на типа означава създаване на друга дестинация',
    kindSmtp: 'Поща (SMTP)',
    kindWebhook: 'Webhook',
    enabled: 'Състояние',
    enabledOn: 'Активна',
    enabledOff: 'Спряна',
    smtpHost: 'SMTP сървър',
    smtpPort: 'Порт',
    smtpPortHint: 'Обичайно: 25 без TLS, 587 със starttls, 465 с tls',
    smtpSecurity: 'Сигурност',
    smtpFrom: 'Изпращач',
    smtpTo: 'Получатели',
    smtpToHint: 'Един или повече адреса, разделени със запетая',
    webhookUrl: 'URL',
    payload: 'Съдържание',
    payloadHint: 'При minimal съобщението и данните на събитието не излизат от кластера',
    credential: 'Идентификационни данни',
    credentialNone: 'Няма',
    credentialHintSmtp: 'Акаунтът на relay от хранилището на ключове; няма означава анонимен SMTP',
    credentialHintWebhook: 'Тайната за подписване от хранилището на ключове; без подпис всеки, който знае URL, може да се представи за кластера',
    minSeverityHint: 'Праг, а не множество: от тази важност нагоре',
    categories: 'Категории',
    categoriesHint: 'Празно = всички',
    types: 'Типове събития',
    typesHint: 'Разделени със запетая; празно = всички. Непознат тип се отказва',
    targetsHint: 'Поне една; трябва да са в обхвата на правилото или в негов предшественик',
    recursiveOn: 'И дъщерните обхвати',
    recursiveOff: 'Само този обхват',
    recursiveHint: 'Ресурсите живеят в листата: без децата правило върху корена уведомява почти за нищо',
    repeatWindow: 'Прозорец за групиране (s)',
    repeatWindowHint: 'В рамките на прозореца повторенията не изпращат поща: броят се при първата. 0 изключва',
    targetInUseError: 'Дестинацията {name} все още се използва от правило'
  }
}
